import { StaffLayout } from "@/components/layouts/staff-layout"
import {
  RecipesWorkspace,
  type RecipesWorkspaceProps,
} from "@/features/staff/inventory/recipes-workspace"

export default function StaffLocationManageRecipesIndex(props: RecipesWorkspaceProps) {
  return (
    <StaffLayout>
      <RecipesWorkspace {...props} />
    </StaffLayout>
  )
}
